import { get } from 'lodash'

export class APIError extends Error {
  constructor (options) {
    super('API Error')

    const { request, response, data } = options
    this.request = request
    this.response = response
    this.data = data
  }
}

/**
 * Client errors
 */

export class NotFoundError extends APIError {}
export class UnauthorizedError extends APIError {}
export class ForbiddenError extends APIError {}
export class BadRequestError extends APIError {}

/**
 * Server errors
 */

export class InternalServerError extends APIError {}

export const transformApiError = error => {
  const errorsArray = get(error.data, 'errors', [])
  const errorObject = errorsArray.reduce((errorMap, err) => {
    const { param = 'global', msg } = err
    return { ...errorMap, [param]: msg }
  }, {})

  return {
    empty: () => errorsArray.length === 0,
    array: (index = null) => index === null ? errorsArray : errorsArray[index],
    object: () => errorObject
  }
}
